import { Transition } from '@uirouter/angularjs';
import { EMAIL_CONFIRMED_SERVICE, EmailConfirmedService } from './email-confirmed.service';
import { IFormController, IOnChangesObject, IComponentController } from "angular";
import { StateService } from '@uirouter/angularjs';
import { DASHBOARD_STATE } from '../dashboard/dashboard.router';
import { isUndefined } from 'lodash';

import './email-confirmed.less';


export class EmailConfirmedController implements IComponentController {
    // from router
    private userIdAndToken: { userId: string, confirmationToken: string };
    private urlResponse: string;
    private form: IFormController;

    private loading: boolean;

    //Labels
    get mainLabel() { return "Registration confirmed"; }
    get description() { return "You can now sign-in!"; }
    get gotoLoginButtonLabel() { return "Go to sign-in page"; }

    static $inject = ["$mdToast", "$state", "$window", EMAIL_CONFIRMED_SERVICE, "BoardWebAdminUserManager"];
    constructor(private $mdToast: ng.material.IToastService, private $state: StateService,
        private $window: ng.IWindowService, private emailConfirmService: EmailConfirmedService, private userManager: Oidc.UserManager) { }

    $onInit() {
        this.loading = true;
        this.emailConfirmService.confirmEmail(this.userIdAndToken.userId, this.userIdAndToken.confirmationToken).then((response) => {
            this.urlResponse = response;
        }).finally(() => { this.loading = false; });
    }
    private gotoLogin() {
        this.userManager.signinRedirect();
    }
}



// WEBPACK FOOTER //
// ./app/email-confirmed/email-confirmed.controller.ts